import Product from "./product";
import formatMoney from "./utils/format-money";

const User = {

  /* Maintains the current state of the user, this will update itself as the user takes action */
  state: {
    isLoggedIn: false,
    id: null,
    isViewingAProduct: false,
    recentlyViewedProducts: null,
    recentlyViewedProductData: null
  },

  /**
   * Gets and sets the users recently viewed products
   *    Get the recently_viewed_products cookie (if it exists)
   *    Parse the cookie data for the product handles
   *    Set this.state.recentlyViewedProducts to an array of (max 4) recently viewed product handles
   *    If this is a product page
   *        - Add this product to the array
   *        - Replace the array in the cookie with the new version
   *    Get data for each product in the array and store in this.state.recentlyViewedProductData
   *    Try populating recently viewed products element
   */
  setRecentlyViewedProducts: async function () {
    let recentlyViewedCookie = document.cookie.match(new RegExp("recently_viewed_products" + '=([^;]+)'))
    let recentlyViewedProducts = recentlyViewedCookie ? JSON.parse(recentlyViewedCookie[1]) : []
    this.state.recentlyViewedProducts = recentlyViewedProducts.slice(0, 4)

    if (this.state.isViewingAProduct) {
      let thisProductHandle = window.location.pathname.split("/").slice(-1).pop()
      recentlyViewedProducts.unshift(thisProductHandle)
      this.state.recentlyViewedProducts = [...new Set(recentlyViewedProducts)].slice(0, 4)
      document.cookie = `recently_viewed_products=${JSON.stringify(this.state.recentlyViewedProducts)}; domain=.${window.location.host.toString()}; path=/;`
    }

    this.state.recentlyViewedProductData = []
    for (let productHandle of this.state.recentlyViewedProducts) {
      let productData = await Product.getData(`/products/${productHandle}`)
      this.state.recentlyViewedProductData.push(productData)
    }

    this.populateRecentlyViewedProducts()
  },

  /**
   * Populated a recently viewed products display
   *    Checks if user is viewing a product and the recently viewed products display is present
   *    Clears the html inside the recently viewed products display
   *    Iterates the recently viewed product data and creates a product card for each
   *    Adds product card to recently viewed products display
   */
  populateRecentlyViewedProducts: function () {
    if (this.state.isViewingAProduct && document.getElementById('recently-viewed-products')) {
      let recentlyViewedProductsContainer = document.getElementById("recently-viewed-products")
      recentlyViewedProductsContainer.innerHTML = ''
      for (let product of this.state.recentlyViewedProductData) {
        /** Check if product is on sale */
        const salePrice = product.compare_at_price;
        let onSale = false;
        if (salePrice != null) {
          onSale = true;
        }
        let thisProductCard = `
          <li class="product-recommendations__list-item">
            <div class="product-card">
              <a href="/products/${product.handle}" title="View ${product.title}">
                <img src="${product.featured_image}" class="card-img-top" alt="${product.title}">
              </a>
              <div class="product-card__body">
                <h5 class="product-card__title"><a href="/products/${product.handle}">${product.title}</a></h5>
                <div class="product-card__price">
                  ${onSale ? ( `
                    <span class="product-card__price--sale">${formatMoney(product.compare_at_price) }</span>
                    <span class="product-card__price--full">${ formatMoney(product.price) }</span>
                  `) : (`
                    <span class="product-card__price--full">${ formatMoney(product.price) }</span>
                  `)}
                </div>
              </div>
            </div>
          </li>
        `
        recentlyViewedProductsContainer.innerHTML += thisProductCard
      }
    }
  },

  /**
   * Initializes a user 
   *    Sets logged in state
   *    Sets whether or not the user is currently viewing a product page
   *    Tracks the users recently viewed products
   * @param {String, Integer} userId - The current user's ID. Should be null if not logged in.
   */
  initialize: async function (userId = null) {
    this.state.isLoggedIn = userId ? true : false
    this.state.id = userId
    if (ShopifyAnalytics && ShopifyAnalytics.meta.page.resourceType == "product") {
      this.state.isViewingAProduct = true
    }
    this.setRecentlyViewedProducts()
  }

}

window.User = User
document.addEventListener("DOMContentLoaded", function () {
  let userId = __st.cid || null
  User.initialize(userId)
})


export default User